import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "question-menu mb-3 d-flex align-center" }
const _hoisted_3 = {
  key: 1,
  class: "ms-3 mt-2"
}
const _hoisted_4 = { class: "pe-0" }
const _hoisted_5 = { class: "course-list" }
const _hoisted_6 = { class: "course-name" }
const _hoisted_7 = { class: "course-stats" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = { class: "course-list" }
const _hoisted_10 = { class: "course-name" }
const _hoisted_11 = { class: "course-stats" }
const _hoisted_12 = { class: "me-2" }

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserQuestion from '../../../api/v2/models/user_question'
import LessonRelative from '../../../api/v2/models/lesson_relative'
import CourseRelative from '../../../api/v2/models/course_relative'
import api from '../../../api/v2/api'
import Pagination from '../../../api/v2/models/pagination'
import QuestionList from '../organisms/QuestionList.vue'
import { checkMobile } from '../../utils/utils'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import { UserQuestionListForm } from '../../../api/v2/forms/user_question'
import { userQuestionState } from '../../stores/user_quetions'
import { headerState } from '../../stores/header'
import { eventBus, EVENTS } from '../../utils/eventBus'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionListPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive Data
const title = ref('すべての質問')
const questions = ref<UserQuestion[]>([])
const userQuestionListForm = ref<UserQuestionListForm>(new UserQuestionListForm())
const pagination = ref<Pagination | null>(null)
const isLoading = ref(true)
const search = ref('')
const searchCourse = ref('')
const model = ref('')
const modelCourse = ref('')
const items = ref<string[]>([])
const courseItems = ref<string[]>([])
const showSideBar = ref(false)
const page = ref(1)
const mobile = ref(checkMobile())
const currentCourse = ref<CourseRelative | null>(null)
const showCourses = ref<CourseRelative[]>([])
const sideBarData = ref<{
  sameLessonQuestions: UserQuestion[],
  sameCourseLessons: LessonRelative[],
  courses: CourseRelative[]
}>({
  sameLessonQuestions: [],
  sameCourseLessons: [],
  courses: []
})
const breadcrumbs = ref([
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'みんなの質問',
    disabled: false,
    exact: true,
    to: '/classroom/questions'
  }
])

// Computed
const getPbMobile = computed(() => mobile.value ? "pb-10" : "")
const courseIdQuery = computed(() => getQueryNumber(route.query, 'course_id'))
const lessonIdQuery = computed(() => getQueryString(route.query, 'lesson_id'))

// Functions
async function selectPage(page: number) {
  userQuestionListForm.value.page = page
  await getList()
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

async function loadSidebar() {
  try {
    sideBarData.value = await api.userQuestion.relativeLists(questions.value[0].id.toString())
    showCourses.value = sideBarData.value.courses
  } catch(e) {
    // Error handling
  }
}

function refreshList() {
  router.replace({ 'query': {} })
  isLoading.value = true
  getList()
}

async function getList() {
  const courseId = courseIdQuery.value
  const lessonId = lessonIdQuery.value

  if (courseId) {
    userQuestionListForm.value.relativeableType = 'Course'
    userQuestionListForm.value.relativeableId = courseId
  } else if (lessonId) {
    userQuestionListForm.value.relativeableType = 'Lesson'
    userQuestionListForm.value.relativeableId = Number(lessonId)
  } else {
    userQuestionListForm.value.relativeableType = undefined
    userQuestionListForm.value.relativeableId = undefined
  }

  try {
    ;[pagination.value, questions.value] = await userQuestionState.fetchList(userQuestionListForm.value)
    if (courseId) {
      const course = await api.course.show(String(courseId))
      title.value = `${course.name}の質問`
    } else if (lessonId) {
      const lesson = await api.lesson.show({ lessonId: lessonId }, "list")
      title.value = `${lesson.name}の質問`
    }
  } catch (e) {
    // Error handling
  } finally {
    isLoading.value = false
  }
}

async function clearSearch() {
  if (search.value) {
    ;[pagination.value, questions.value] = await userQuestionState.fetchMyList()
    search.value = ''
  }
}

// Watchers
watch(search, async () => {
  try {
    userQuestionListForm.value.search = search.value
    await getList()
  } catch (e) {
    // Error handling
  } finally {
    isLoading.value = false
  }
})

watch(searchCourse, () => {
  if (searchCourse.value != null && searchCourse.value.length > 0) {
    showCourses.value = sideBarData.value.courses.filter((course) => course.name.includes(searchCourse.value))
  } else {
    showCourses.value = sideBarData.value.courses
  }
})

watch(() => route.query, () => {
  getList()
})

// Lifecycle
onMounted(() => {
  eventBus.on(EVENTS.QUESTION_CREATED, refreshList)
})

onUnmounted(() => {
  eventBus.off(EVENTS.QUESTION_CREATED, refreshList)
})

// Created logic
;(async () => {
  headerState.setTitle('みんなの質問')
  
  await getList()

  if (questions.value.length > 0) {
    await loadSidebar()
  }
})()

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'みんなの質問' }
    ] }),
    _createCommentVNode(" Main content "),
    _createVNode(_component_v_row, {
      class: "ma-0",
      style: { minHeight: '700px' }
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" Main column: Question list "),
        _createVNode(_component_v_col, {
          cols: mobile.value ? 12 : 8,
          lg: sideBarData.value.courses.length > 0 ? 8 : 12,
          class: "pt-0 bg-white"
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Tabs "),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_col, {
                lg: "10",
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, { to: "/classroom/my-questions" }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("マイ質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_tab, { to: "/classroom/questions" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("みんなの質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_tab, { to: "/classroom/my-answer-questions" }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("アンサーした質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              (mobile.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "text",
                    size: "small",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showSideBar.value = true)),
                    class: "me-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-filter-variant", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (!mobile.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    lg: "2",
                    class: "text-end pa-0 pe-2 d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UserQuestionDialog)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Search bar row "),
            _createVNode(_component_v_row, {
              class: "align-center px-3 py-2",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  md: "9"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                      placeholder: "キーワードを入力してください",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  md: "3",
                  class: "d-flex justify-end align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      onClick: clearSearch
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("クリア", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Loading skeleton "),
            (isLoading.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array.from(Array(10).keys()), (item, index) => {
                  return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: index,
                    ref_for: true,
                    ref: "skeleton",
                    type: "list-item-avatar-three-line",
                    class: "mx-auto"
                  }))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Current course header "),
            (currentCourse.value)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(currentCourse.value.name) + " (" + _toDisplayString(currentCourse.value.questionCount) + ")", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Question list "),
            _createVNode(QuestionList, { questions: questions.value }, null, 8 /* PROPS */, ["questions"]),
            _createCommentVNode(" Pagination "),
            (questions.value.length > 0 && pagination.value && pagination.value.totalPages > 1)
              ? (_openBlock(), _createBlock(_component_v_pagination, {
                  key: 2,
                  modelValue: pagination.value.page,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((pagination.value.page) = $event)),
                    selectPage
                  ],
                  length: pagination.value.totalPages,
                  "active-color": "primary"
                }, null, 8 /* PROPS */, ["modelValue", "length"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["cols", "lg"]),
        (!mobile.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (sideBarData.value.courses.length > 0)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    lg: "4",
                    class: "bg-white px-4 pt-3",
                    style: {"border-left":"1px solid #e0e0e0"}
                  }, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "mb-3" }, "講座別質問", -1 /* CACHED */)),
                      _createVNode(_component_v_divider, { class: "mb-3" }),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_text_field, {
                          modelValue: searchCourse.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchCourse).value = $event)),
                          placeholder: "講座名を入力してください",
                          "prepend-inner-icon": "mdi-magnify",
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "",
                          clearable: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showCourses.value, (course) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: course.id,
                            to: `/classroom/questions?course_id=${course.id}`,
                            class: _normalizeClass(["course-item", { 'course-item-active': courseIdQuery.value === Number(course.id) }])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(course.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, "質問数 " + _toDisplayString(course.questionCount), 1 /* TEXT */),
                                _createElementVNode("span", null, "解決数 " + _toDisplayString(course.answerCount), 1 /* TEXT */)
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createBlock(_component_v_navigation_drawer, {
              key: 1,
              modelValue: showSideBar.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showSideBar).value = $event)),
              absolute: "",
              temporary: "",
              right: "",
              class: "bg-white"
            }, {
              default: _withCtx(() => [
                (sideBarData.value.courses.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      class: "bg-white pa-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "mb-3" }, "講座別質問", -1 /* CACHED */)),
                        _createVNode(_component_v_divider, { class: "mb-3" }),
                        _createVNode(_component_v_col, { class: "pa-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: searchCourse.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchCourse).value = $event)),
                              placeholder: "講座名を入力してください",
                              "prepend-inner-icon": "mdi-magnify",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              clearable: ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showCourses.value, (course) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: course.id,
                              to: `/classroom/questions?course_id=${course.id}`,
                              class: _normalizeClass(["course-item", { 'course-item-active': courseIdQuery.value === Number(course.id) }])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(course.name), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("span", _hoisted_12, "質問数 " + _toDisplayString(course.questionCount), 1 /* TEXT */),
                                  _createElementVNode("span", null, "解決数 " + _toDisplayString(course.answerCount), 1 /* TEXT */)
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]))
      ]),
      _: 1 /* STABLE */
    }),
    (mobile.value)
      ? (_openBlock(), _createBlock(_component_v_footer, {
          key: 0,
          fixed: true,
          class: "justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(UserQuestionDialog)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})